import { Injectable }           from '@angular/core';
import { Http, Response }       from '@angular/http';
import { Observable }           from 'rxjs/Observable';
import { FileUploader }         from 'ng2-file-upload';
import { ConfigService }        from '../configuracion/config.service';
import { RequestBaseService }   from '../request-base/request-base.service';
import { JwtHttp, AuthService } from 'ng2-ui-auth';

import 'rxjs/add/operator/map';

@Injectable()
export class NoticiasService extends RequestBaseService {
  constructor(
    protected http: JwtHttp,
    protected auth: AuthService,
    config: ConfigService
  ) {
    super(http, auth);
    this.ApiUrl = [config.getApiUrl(), 'noticia'].join('/');
  }

  public save(model: any): Observable<any> {
    let file: FileUploader = model.imagen;

    model.imagen = '';
    model.activo = 1;

    return new Observable(observer => {
      super.save(model)
        .subscribe(
          data => {
            if (file.queue.length > 0) {
              file.authToken = this.auth.getToken();
              file.options.url = [this.ApiUrl, data.id, 'upload'].join('/');
              file.queue[0].url = [this.ApiUrl, data.id, 'upload'].join('/');

              file.queue[0].upload();

              file.queue[0]._xhr.onreadystatechange = function(e) {
                if (file.queue[0]._xhr.readyState == 4) {
                  data.image = [data.id, 'jpg'].join('.');

                  observer.next(data);
                }
              }
            } else {
              observer.next(data);
            }
          },
          error => console.error(error)
        );      
    });
  }

  public update(id:any, model: any): Observable<any> {
    let file: FileUploader = model.imagen;

    model.imagen = [id, 'jpg'].join('.');

    return new Observable(observer => {
      super.update(id, model)
        .subscribe(
          data => {
            if (file.queue.length > 0) {
              file.authToken = this.auth.getToken();
              file.options.url = [this.ApiUrl, data.id, 'upload'].join('/');
              file.queue[0].url = [this.ApiUrl, data.id, 'upload'].join('/');

              file.queue[0].upload();

              file.queue[0]._xhr.onreadystatechange = function(e) {
                if (file.queue[0]._xhr.readyState == 4) {
                  data.image = [data.id, 'jpg'].join('.');

                  observer.next(data);
                }
              }
            } else {
              observer.next(data);
            }
          },
          error => console.error(error)
        );      
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/noticias/noticias.service.ts